import React from 'react';

const Reset = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="40" height="40" rx="20" fill="#F5F5FC" />
      <path
        d="M13.0779 16C14.4678 13.6088 17.0657 12 20.0412 12C23.4149 12 26.3031 14.0682 27.4957 17M15.5194 17H11.5V13M26.9221 24C25.5322 26.3912 22.9343 28 19.9588 28C16.5851 28 13.6969 25.9318 12.5043 23M24.4806 23H28.5V27"
        stroke="#1B1F4D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Reset;
